import {
  DictOption,
  DictType,
  FileAcl,
  FileInfo,
  PromiseResponseProps,
  ResponseProps,
} from "@/config/types/common";
import request, { preHandleResponse } from "@/utils/request";
import { useInfiniteQuery } from "@tanstack/react-query";
import { MemberItem } from "@/config/types/workshop";
// import localExpiredStorage from "@italent/local-expired-storage";

/**
 * 登录
 */
export function login(data: {
  authMethod?: string;
  username?: string;
  password?: string;
  checkCode?: string;
}) {
  return request({
    url: "/auth_app/v1/get_access_token",
    method: "post",
    data,
  }) as any;
}
/**
 * 发送验证码
 */
export function sendSmsCode(data: { mobile: string }) {
  return request({
    url: "/auth_app/v1/send_sm_code",
    method: "post",
    data,
  }) as any;
}

export function aliAuth(captchaVerifyParam: string) {
  return request({
    url: `/auth_app/v1/simple_check`,
    method: "post",
    data: { captchaVerifyParam },
  }) as any;
}

// 获取字典项
export function batchGetDict(
  nameList: DictType[]
): PromiseResponseProps<{ [key in DictType]: DictOption[] }> {
  return request({
    url: "/dict/v1/item/query_tree_list_by_name",
    method: "post",
    data: { nameList },
  });
}

// 根据调用名 获取分类树
// export async function getCategoryViaAlias(alias: string[]) {
//   const cacheKey = `category-${alias}`;
//   const cacheValue = localExpiredStorage.getItem(cacheKey);
//   if (cacheValue) {
//     return cacheValue;
//   }
//   try {
//     const result: any = await request({
//       url: "/api/base/category/v1/by-alias",
//       method: "post",
//       data: { alias },
//     });
//     if (result.code === API_RESULT_CODE.SUCCESS) {
//       localExpiredStorage.setItem(cacheKey, result);
//     }
//     return result;
//   } catch (err) {
//     console.error(err);
//   }
//   return null;
// }

/*
 * 获取模块信息
 * 备注：这个接口是针对特定调用名获取内容的公共接口，后端有白名单校验；
 * @see http://apidoc.stac.fun/project/682/interface/api/65301
 */
export function aliasModule(moduleContentCode: string) {
  return request({
    url: `/module/v1/open_module`,
    method: "post",
    data: { moduleContentCode },
  }) as any;
}

/*
 * 获取模块列表（鉴权）
 * @see http://apidoc.stac.fun/project/682/interface/api/73811
 */
export function aliasAuthModuleList(moduleCode: string) {
  return request({
    url: `/module/v1/query_by_module_code`,
    method: "post",
    data: { moduleCode },
  }) as any;
}

/*
 * 获取模块内容（鉴权）
 * @see http://apidoc.stac.fun/project/682/interface/api/63846
 */
export function aliasAuthModuleContent(moduleContentCode: string) {
  return request({
    url: `/module/v1/query_content_by_module_content_code`,
    method: "post",
    data: { moduleContentCode },
  }) as any;
}

// 获取签名url
export function getSignUrl(data: {
  md5?: string;
  fileType: string; //文件后缀名，没有.
  contentType?: string;
  fileName: string; // 文件名称
  contentLength: string; // 文件大小 eg:164556443
  resourceType: string; // 资源类型，图片image\视频video
  expireTimeMinute?: number; // 过期时间，默认15分钟
  acl: FileAcl; // 私有\公有 private\public-read
}): PromiseResponseProps<{ signUrl: string; filePath: string; fileId: string }> {
  return request({
    url: "/file/v1/get_sign_url",
    method: "post",
    data,
  });
}

// 保存上传文件信息
export function saveFileInfo(
  data: FileInfo
): PromiseResponseProps<{ id: string; url: string; fileName: string }> {
  return request({
    url: "/file/v1/save_upload_file_info",
    method: "post",
    data: { storageType: "minio", ...data },
  });
}

export function getUserInfo() {
  return request({
    url: "/auth_app/v1/get_user_info",
  });
}

// 搜索用户
// http://apidoc.stac.fun/project/682/interface/api/84126
export function useQueryUsers(data: { keyWords?: string; companyCode?: string }, enabled = true) {
  return useInfiniteQuery({
    queryKey: ["queryUsers", data, enabled],
    initialPageParam: {
      pageNum: 1,
      pageSize: 100,
      ...data,
    },
    queryFn: async ({ pageParam }) => {
      const response: ResponseProps<MemberItem[]> = await request({
        url: "/chuangzhi_chenter/v1/search_users",
        method: "post",
        data: pageParam,
      });
      return preHandleResponse(response);
    },
    getNextPageParam: (lastPage, pages, lastPageParam) => {
      if (!lastPage || !lastPage?.length) return null;
      return {
        ...lastPageParam,
        pageNum: lastPageParam.pageNum + 1,
      };
    },
    enabled: !!data.keyWords && enabled,
  });
}
